<template>
    <div class="bottom-nav bg-white border-top-radius elevation-1 d-flex justify-content-between">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "BottomNavigation"
    }
</script>

<style scoped>
    .bottom-nav {
        padding: 0 1rem;
        padding-top: .5rem;
    }
</style>
